export default __webpack_public_path__ + "static/media/DTprotoCover.d9b22d58.jpg";